<div class="date-picker-container">
  <div class="input-wrapper" [ngClass]="{'input-error': showError(), 'disabled': formControl && formControl.disabled}">
    <!-- will be using mis calender here -->
    <!-- <mbsc-calendar [(ngModel)]="date"  [ngClass]="{'disabled-datepicker': formControl && formControl.disabled}" class="custom-calendar" [(options)]="settings" placeholder="Select date"></mbsc-calendar> -->
    <img class="suffix input-icon" src="assets/calendar.svg" />
  </div>
  <div class="error-msg" *ngIf="showError() && formControl.errors.required">{{errorMessages.required}}</div>
</div>
